import { render } from "./SubscriptionPayModal.vue?vue&type=template&id=b2c21a6c"
import script from "./SubscriptionPayModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionPayModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__